export default "__VITE_ASSET__CtBEWMUO__"